export default __webpack_public_path__ + "static/media/Insta2.233812b9.png";